/* eslint-disable */
export const paths = {
  RAV: "rav",
  INBOX: "inbox",
  EDIT_BP_CUFF_SHIPMENT_ADDRESS: "editBpCuffShipmentAddress",
  OPT_OUT_BP_CUFF_SHIPMENT: "optOutBpCuffShipment",
  CONSULT_ASSESSMENT: "consultAssessment",
  CARE_PLAN: "carePlan",
  DYNAMIC_TEMPLATES: "dynamicTemplate",
  CARE_TEAM: "careTeam",
  CARE_TEAM_SELECT: "careTeamSelect",
  VITALS: "vitals",
  PRICING_TABLE: "pricingTable",
  MESSAGE_CENTER: "messageCenter",
  ACCOUNT_SETTINGS: "accountSettings",
  MEDICAL_HISTORY: "medicalHistory",
  JOIN_WAITING_ROOM: "joinWaitingRoom",
  EXPERT_MEDICAL_OPINION: "expertMedicalOpinion",
  MENTAL_HEALTH_NAVIGATOR: "mentalHealthNavigator",
  PERSONAL_HEALTH_NAVIGATOR: "personalHealthNavigator",
  FIND_BEST_DOCTOR: "findBestDoctor",
  BACK_CARE: "backCare",
  DASHBOARD: "dashboard",
  REGISTRATION: "registration",
  INSURANCE_SETTINGS: "insuranceSettings",
  RESCHEDULE_GM_VISIT: "rescheduleGMVisit",
  RESCHEDULE_MH_VISIT: "rescheduleMHVisit",
  VISIT_CANCELLATION: "visitCancellation",
  INVOICES: "invoices",
  PRICE_PRESCRIPTIONS: "pricePrescriptions",
  PRICE_PROCEDURES: "priceProcedures",
  FIND_PROVIDERS: "findProviders",
  FIND_RECIPES: "findRecipes",
  FIND_FACILITIES: "findFacilities",
  SDK_APPOINTMENT_LIST: "sdkAppointmentList",
  SDK_SERVICES: "sdkServices",
  SDK_START_VIDEO: "sdkStartVideo",
  SDK_APPOINTMENT_LIST_REFRESH: "sdkAppointmentListRefresh",
  SDK_DASHBOARD: "sdkDashboard",
  SDK_CONSENT_AGREEMENTS: "sdkConsentAgreements",
  ELITE_DIAGNOSTIC_IMAGING_SERVICE: "eliteDiagnosticImagingService",
  DFD_DASHBOARD: "homepage",
  SELECT_ACCOUNT: "selectAccount",
  RECOVER_USERNAME: "recoverUsername",
  FORGOT_PASSWORD: "forgotPassword",
  SECURE_YOUR_ACCOUNT: "secureYourAccount",
  RECOVER_PASSWORD: "recoverPassword",
  WELCOME_PAGE: "welcomePage",
  THANK_YOU: "thankYou",
  CANCEL: "cancel",
  CARE_OPTION: "careOption",
  MEET_LIVONGO: "meetLivongo",
  UNI_SIGNIN: "uniSignin",
  UNI_REGISTRATION: "uniRegistration",
  UNIFIED_PROFILE: "unifiedProfile",
  MYSTRENGTH_ACTIVITY: "mystrengthActivity",
  MYSTRENGTH_MODERNIZED_COMPONENTS: "mystrengthModernizedComponents",
  MYSTRENGTH_INTEGRATION: "mystrengthIntegration",
  MYSTRENGTH_SLEEP_TRACKER: "mystrengthSleepTracker",
  MYSTRENGTH_HISTORY: "mystrengthHistory",
  MYSTRENGTH_GET_HELP: "mystrengthGetHelp",
  MYSTRENGTH_CONTENT_PREFERENCES: "mystrengthContentPreferences",
  MYSTRENGTH_CRISIS: "myStrengthCrisis",
  MYSTRENGTH_DIARY_ENTRIES: "mystrengthDiaryEntries",
  MYSTRENGTH_GUIDES: "mystrengthGuides",
  MYSTRENGTH_CREATE_SLEEP_SCHEDULE: "mystrengthCreateSleepSchedule",
  MYSTRENGTH_SLEEP_TRACKER_PROGRESS: "mystrengthSleepTrackerProgress",
  MYSTRENGTH_WEEKLY_CHECKIN: "mystrengthWeeklyCheckin",
  MYSTRENGTH_EDIT_SLEEP_SCHEDULE: "mystrengthEditSleepSchedule",
  CHECKLIST: "checklist",
  BASIC_PROFILE: "basicProfile",
  SECURITY_AND_SIGN_IN: "securityAndSignIn",
  EMERGENCY_CONTACT: "emergencyContact",
  COVERAGE_AND_BILLING: "coverageAndBilling",
  LANGUAGE_MENU: "languageMenu",
  MY_FAMILY: "myFamily",
  HELP: "help",
  COMMUNICATION_PREFERENCES: "communicationPreferences",
  ALL_CARE_OPTIONS: "allCareOptions",
  MINOR_INVITATION_CONSENTS: "invitationConsents",
  VERIFY_IDENTITY: "verifyIdentity",
  MYSTRENGTH_INTERSTITIAL_PAGE: "mystrengthInterstitialPage",
  MYSTRENGTH_INTERSTITIAL_PAGE_REDIRECT_TO_MH_PLATFORM:
    "mystrengthInterstitialPageRedirectToMHPlatform",
  TOBACCO_CESSATION: "tobaccoCessation",
  TWO_STEP: "twoStep",
  CCM_SSO: "ccmSso",
  SEXUAL_HEALTH: "sexualHealth",
  CARE_RECIPIENTS: "careRecipients",
  COVID_ASSESSMENT: "covidAssessment",
  DEPENDANT_LIST: "dependentList",
  AUTHORIZED_CONSENTERS: "authorizedConsenters",
  OTHER_PROVIDERS: "otherProviders",
  PHARMACIES: "pharmacies",
  IMAGES_AND_DOCUMENTS: "imagesAndDocuments",
  VISITS: "visits",
  CASES: "cases",
  HEALTH: "health"
};
